export enum AuthErrorExtensions {
    Unauthenticated = 401
}
